import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Column from './Column/Column';

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    height: 0
  };

  render() {
    return (
      <footer className="footer">
        <div className="footer__container">
          <Column title="Call Center Hours">
            <div className="footer__container__column__wrapper__contentContainer__contact">
              <div className="footer__container__column__contentContainer__contact--times">
                <p>Monday To Friday: 5:00am to Midnight CST</p>
                <p>Saturday and Sunday: 5:00am to 8:00pm CST</p>
              </div>
            </div>
            <div className="footer__container__column__wrapper__contentContainer__contact">
              <div className="footer__container__column__wrapper__contentContainer__contact--icon">
                <i className="fas fa-phone" />
              </div>
              <p>
                Toll-Free: 1-877-768-7230 <br /> Fax: 1-586-630-3029
              </p>
            </div>
            <div className="footer__container__column__wrapper__contentContainer__contact">
              <div className="footer__container__column__wrapper__contentContainer__contact--icon">
                <i className="fas fa-at" />
              </div>
              <p>
                For General Inquiries:
                <br /> info@medsourceinternational.com
              </p>
            </div>
          </Column>
          <Column title="Mailing Address">
            <div className="footer__container__column__wrapper__contentContainer__list">
              <ul>
                <li>
                  Med Source International <br /> 803 W. Big Beaver Rd. Suite
                  355
                  <br />
                  Troy, MI 48084
                </li>
              </ul>
            </div>
          </Column>
          {/* <div className="footer__container__column">
            <div className="footer__container__column__headerContainer">
              <h3 className="footer__container__column__headerContainer__header">
                Stamp
              </h3>
            </div>
            <div className="footer__container__column__contentContainer">
              <div className="footer__container__column__contentContainer__stamp">
                <img src="./assets/stamp.png" alt="" />
              </div>
            </div>
          </div> */}
          <Column title="Pharmacy Hours">
            <div className="footer__container__column__wrapper__contentContainer__list">
              <ul>
                <li>
                  <p>
                    Monday - Friday <span>5:00am - Midnight CST</span>
                  </p>
                </li>
                <li>
                  <p>
                    Saturday and Sunday <span>Closed</span>
                  </p>
                </li>
              </ul>
            </div>
          </Column>
          <div style={{ clear: 'both' }} />
        </div>
        <div className="footer__trademark">
          <p>
            Copyright &copy; 2018{' '}
            <span>
              <Link to="/">MedSource</Link>
            </span>
            . All Rights Reserved.
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js